import React from 'react'
import { Form } from "react-bootstrap";


export default function UiSingleLineInput(props) {

    return (
        <>
         <div className='sb-single-line-input'>
            <Form.Group>
                <Form.Control
                    type={props.type}
                    placeholder={props.placeholder}
                    value={props.value}
                    id={props.label}

                />
                <Form.Control.Feedback type={props.errorType}>
                    {props.errorMsg}
                </Form.Control.Feedback>
            </Form.Group>
        </div>
        </>
    )
}
